module.exports = __webpack_public_path__ + "static/media/newchat.dde17edd.svg";